import './Bibliographies.sass';

import moment from 'moment';
import React from 'react';
import { CSVLink } from 'react-csv';
import _ from 'underscore';

import CheckBoxList from '../../../commonComponents/CheckBoxList/CheckBoxList';
import DropDown from '../../../commonComponents/DropDown/DropDown';
import BibliographyLogs from '../../../commonComponents/Modals/BibliographyLogs/BibliographyLogs';
import CreateChapter from '../../../commonComponents/Modals/CreateChapter/CreateChapter';
import CreateReference from '../../../commonComponents/Modals/CreateReference/CreateReference';
import SimpleConfirmation from '../../../commonComponents/Modals/SimpleConfirmation/SimpleConfirmation';
import Spinner from '../../../commonComponents/Spinner/Spinner';
import { CYCLE_TYPES } from '../../../constants/examConstants';
import NumberUtils from '../../../lib/NumberUtils';
import { getRatingExam } from '../../../utilities/getItemsHelper';
import { canPerformAction } from '../../../utilities/permissionUtils';
import CyclesContainer from '../../Cycles/components/CyclesContainer';
import BibliographyList from './BibliographyList/BibliographyList';

export default class NewBibliographies extends React.Component {
  state = {
    selectAllReferences: false,
    itemsReferences: [],
    isViewSelected: false,
    filename: 'bibliography.csv',
    reportFilename: 'report.csv',
    substituteLinked: false,
    reserveLinked: false,
    highlightBook: this.props.references.highlightBook,
    initialCheckedReferences: [],
    deselectedCount: 0,
    selectedChapterIds: new Set(),
  };

  componentDidMount() {
    this.props.loadCycles();
    this.props.loadRates();
    this.props.setRatingExamQuestions();
    this.props.setIsUndoChecked(true);
    this.props.setIsRevertChecked(true);

    // Auto-load exam data for the current or first rate
    const { rates, rate, activeListTab } = this.props;
    if (activeListTab === 'AFSC Exam' && rates.length > 1) {
      const selectedRate = rate.id
        ? rates.find((r) => r.id === rate.id) || rates.find((r) => r.id !== 0)
        : rates.find((r) => r.id !== 0);
      if (selectedRate) {
        this.onListUpdate(selectedRate, this.props.rank, this.props.dutyState);
      }
    }
  }

  componentWillReceiveProps({
    referencesImmutable,
    checkedReferences,
    waiting,
    references,
    rate,
    ratingExamQuestions,
    loadingGrid,
    loadingExam,
  }) {
    const questions = ratingExamQuestions
      ? ratingExamQuestions.find(
          (a) =>
            a.rank === this.props.rank &&
            a.dutyState === this.props.dutyState &&
            a.rate === rate.id,
        )
      : null;
    if (questions) {
      questions.linkedRatingExam &&
      questions.linkedRatingExam.indexOf('Substitute') !== -1
        ? this.setState({ substituteLinked: true })
        : this.setState({ substituteLinked: false });
      questions.linkedRatingExam &&
      questions.linkedRatingExam.indexOf('Reserve') !== -1
        ? this.setState({ reserveLinked: true })
        : this.setState({ reserveLinked: false });
    } else {
      this.setState({ substituteLinked: false });
    }

    if (this.props.referencesImmutable !== referencesImmutable) {
      this.convertReferencesFromServer(references, checkedReferences);
    }

    if (this.props.checkedReferences !== checkedReferences) {
      this.convertReferencesFromServer(references, checkedReferences);
    }

    if (references !== this.state.itemsReferences) {
      this.setState({
        itemsReferences: this.convertReferencesFromServer(
          references,
          checkedReferences,
          true,
        ),
      });
    }

    if (
      this.props.loadingGrid !== loadingGrid ||
      this.props.loadingExam !== loadingExam
    ) {
      this.setState({
        initialCheckedReferences: [...checkedReferences],
        deselectedCount: 0,
      });
    }

    if (waiting !== this.props.waiting && !waiting) {
      this.props.closeModal();
    }

    if (this.props.checkedReferences !== checkedReferences) {
      if (checkedReferences && checkedReferences.length === 0) {
        this.setState({ selectedChapterIds: new Set(checkedReferences) });
      }
    }
  }

  componentDidUpdate() {
    if (this.props.bibliographyJson) {
      document.getElementById('download').click();
      this.props.clearBibJson();
      this.setState({ filename: 'bibliography.csv' });
    }
    if (this.props.rateChapterQuestionsReport) {
      document.getElementById('downloadReport').click();
      this.props.clearBibJson();
      this.setState({ reportFilename: 'report.csv' });
    }
  }

  addManyToSelection = (ids = []) => {
    this.setState((prev) => {
      const next = new Set(prev.selectedChapterIds);
      ids.forEach((id) => next.add(id));
      return { selectedChapterIds: next };
    });
  };

  removeManyFromSelection = (ids = []) => {
    this.setState((prev) => {
      const next = new Set(prev.selectedChapterIds);
      ids.forEach((id) => next.delete(id));
      return { selectedChapterIds: next };
    });
  };

  toggleOneInSelection = (id, checked) => {
    this.setState((prev) => {
      const next = new Set(prev.selectedChapterIds);
      if (checked) next.add(id);
      else next.delete(id);
      return { selectedChapterIds: next };
    });
  };

  loadContent = (rateId) => {
    this.props.loadReferences(rateId, 'rate');
  };

  convertChaptersFromServer = (reference, checkedReferencesIds = []) => {
    let chapters = [];
    if (reference.chapters && reference.chapters.length > 0) {
      const checkedReferences = reference.chapters.filter(
        (chapter) => checkedReferencesIds.indexOf(chapter.id) !== -1,
      );
      chapters = reference.chapters.map((chapter) => ({
        id: chapter.id,
        name: chapter.name,
        questionCount: chapter.questionCount,
        checked: !!checkedReferences.find(
          (chapterAux) => chapterAux.id === chapter.id,
        ),
        enabled: chapter.enabled,
        description: chapter.description,
        highlightChapter: chapter.highlightChapter,
      }));
    } else if (!reference.actAsParent) {
      chapters.push({
        name: reference.name,
        id: reference.id,
        checked: false,
        description: reference.description,
      });
    }
    return chapters;
  };

  convertReferencesFromServer = (
    references,
    checkedReferencesIds = this.props.checkedReferences,
    isReturn = false,
  ) => {
    let itemsReferences = [];

    if (references) {
      itemsReferences = references.map((reference) => ({
        name: reference.name,
        actAsParent: reference.actAsParent,
        highlightBook: reference.highlightBook,
        chapters: this.convertChaptersFromServer(
          reference,
          checkedReferencesIds,
        ),
        description: reference.description,
      }));
    }
    if (this.state.reverseRefs) {
      itemsReferences = _.sortBy(itemsReferences, 'name').reverse();
    } else {
      itemsReferences = _.sortBy(itemsReferences, 'name');
    }
    if (isReturn) {
      return itemsReferences;
    }

    this.setState({
      itemsReferences,
      deselectedCount: this.state.initialCheckedReferences?.filter(
        (id) => !checkedReferencesIds.includes(id),
      ).length,
    });
  };

  filterCycles = (rank = this.props.rank, dutyState = this.props.dutyState) => {
    const type = CYCLE_TYPES[dutyState][rank];
    return this.props.cycles.filter((cycle) => cycle.type === type);
  };

  updatebib = (bib) => {
    const fromRegular = true;
    const bibliography = bib;
    bibliography.fromRegular = fromRegular;
    const { ratingExamQuestions = [], rate } = this.props;
    const questions = ratingExamQuestions.find(
      (a) =>
        a.rank === bibliography.rank &&
        a.dutyState === bibliography.dutyState &&
        a.rate === rate.id,
    );
    if (questions) {
      if (!questions.linkedRatingExam) {
        bibliography.whichUpdate = 'Regular';
        this.props.submitBibliography(bibliography);
      } else {
        const question = JSON.parse(questions.linkedRatingExam);
        question.forEach((element) => {
          if (element.Substitute) {
            bibliography.whichUpdate =
              bibliography.whichUpdate && bibliography.whichUpdate === 'Reserve'
                ? (bibliography.whichUpdate = 'All')
                : (bibliography.whichUpdate = 'Substitute');
          } else if (element.Reserve) {
            bibliography.whichUpdate =
              bibliography.whichUpdate &&
              bibliography.whichUpdate === 'Substitute'
                ? (bibliography.whichUpdate = 'All')
                : (bibliography.whichUpdate = 'Reserve');
          }
        });
        this.props.submitBibliography(bibliography);
      }
    } else {
      this.props.submitBibliography(bibliography);
    }
  };

  handleUndo = () => {
    this.props.openModal({
      modalTitle: `Undo bibliography update`,
      modalContent: (
        <SimpleConfirmation
          onConfirm={() => {
            this.props.setIsUndoChecked(true);
            this.props.setIsRevertChecked(false);
            this.updateUndo();
          }}
          onCancel={this.props.closeModal}
          text={
            <div>
              {`Are you sure you want to undo the bibliography update for the ${this.props.rate.shortname} -> ${this.props.rank} exam?`}
            </div>
          }
          greenButton
        />
      ),
    });
  };

  handleRevert = () => {
    this.props.openModal({
      modalTitle: `Revert bibliography update`,
      modalContent: (
        <SimpleConfirmation
          onConfirm={() => {
            this.props.setIsUndoChecked(false);
            this.props.setIsRevertChecked(true);
            this.updateUndo();
          }}
          onCancel={this.props.closeModal}
          text={
            <div>
              {`Are you sure you want to revert the bibliography update for the ${this.props.rate.shortname} -> ${this.props.rank} exam?`}
            </div>
          }
          greenButton
        />
      ),
    });
  };

  updateUndo = () => {
    const undoState = { ...this.props.getUndoState };
    const actualState = { ...this.props.getActualState };
    const { chapters } = undoState;
    this.props.updateCheckedReferences(chapters);
    this.props.setUndoState(actualState);
    this.props.setActualState(undoState);
    this.updatebib(undoState);
  };

  handleSubmit = () => {
    const { checkedReferences, originalCheckedReferences } = this.props;
    let undoState = null;
    if (this.props.isUndoChecked) {
      undoState = {
        rank: this.props.rank,
        dutyState: this.props.dutyState,
        rate: this.props.rate.id,
        cycle: this.props.cycle.id,
        chapters: originalCheckedReferences,
      };
    }
    const bibliography = {
      rank: this.props.rank,
      dutyState: this.props.dutyState,
      rate: this.props.rate.id,
      cycle: this.props.cycle.id,
      chapters: checkedReferences,
      selectedChapterIds: [...this.state.selectedChapterIds],
    };
    this.props.openModal({
      modalTitle: `Submitting bibliography`,
      modalContent: (
        <SimpleConfirmation
          onConfirm={() => {
            if (this.props.getUndoState && this.props.getActualState) {
              const actualState = { ...this.props.getActualState };
              this.props.setUndoState(actualState);
              this.props.setActualState(bibliography);
            } else {
              this.props.setUndoState(undoState);
              this.props.setActualState(bibliography);
            }
            this.props.setIsRevertChecked(true);
            this.props.setIsUndoChecked(false);
            this.updatebib(bibliography);

            // Refresh current tab content after submitting the bibliography
            if (bibliography.rate) {
              this.loadContent(bibliography.rate);
            }

            this.setState({
              initialCheckedReferences: this.props.checkedReferences,
              deselectedCount: 0,
            });
          }}
          onCancel={this.props.closeModal}
          text={
            <>
              {this.state.deselectedCount >= 10 && (
                <div className="danger">
                  You are deselecting {this.state.deselectedCount} chapters.
                </div>
              )}
              <div>
                {`Are you sure you want to update the bibliography for the ${this.props.rate.shortname} -> ${this.props.rank} exam?`}
              </div>
            </>
          }
          greenButton
        />
      ),
    });
  };

  handleCreateReference = () => {
    this.props.openModal({
      modalContent: (
        <CreateReference
          onSubmit={(fields) =>
            this.props.createReference(fields, this.props.rate.id)
          }
          onCancel={this.props.closeModal}
        />
      ),
      modalClassName: 'modal-create-chapter',
      className: '',
    });
  };

  handleCreateChapter = (referenceName) => {
    this.props.openModal({
      modalContent: (
        <CreateChapter
          onSubmit={(fields) => this.props.createChapter(fields)}
          onCancel={this.props.closeModal}
          references={this.props.references.filter(
            (ref) => ref.actAsParent && ref.name === referenceName,
          )}
        />
      ),
      modalClassName: 'modal-create-chapter',
      className: '',
    });
  };

  handleViewLogs = () => {
    const { rate, rank, dutyState, closeModal } = this.props;
    this.props.openModal({
      modalContent: (
        <BibliographyLogs
          ratingExam={getRatingExam(rate.shortname, rank)}
          dutyState={dutyState}
          onClose={closeModal}
        />
      ),
      modalClassName: 'modal-create-chapter log-modal',
      className: '',
    });
  };

  handleDownloadCSV = () => {
    this.props.loadRateBibliographyJson(this.props.rate.id);
    this.setState({
      filename: `${this.props.rate.shortname}-${moment().format(
        'MMM',
      )}${moment().format('DD')}-${moment().format('YYYY')}.csv`,
    });
  };

  handleDownloadReport = () => {
    this.props.loadRateChapterQuestionsReport(this.props.rate.id);
    this.setState({
      filename: `${this.props.rate.shortname}-${moment().format(
        'MMM',
      )}${moment().format('DD')}-${moment().format('YYYY')}-report.csv`,
    });
  };

  handleSubsLink = () => {
    const { checkedReferences } = this.props;
    const bibliography = {
      rank: this.props.rank,
      dutyState: this.props.dutyState,
      rate: this.props.rate.id,
      cycle: this.props.cycle.id,
      fromRegular: false,
      chapters: checkedReferences,
    };
    const subs = this.state.substituteLinked ? 'Unlink from' : 'Link to';
    if (bibliography.dutyState === 'Regular') {
      bibliography.substituteLinked = this.state.substituteLinked === false;
    }
    this.props.openModal({
      modalTitle: `Link Substitute information`,
      modalContent: (
        <SimpleConfirmation
          onConfirm={() => this.props.submitBibliography(bibliography)}
          onCancel={this.props.closeModal}
          text={<div>{`Are you sure you want to ${subs}substitute?`}</div>}
          greenButton
        />
      ),
    });
  };

  handleReserveLink = () => {
    const { checkedReferences } = this.props;
    const bibliography = {
      rank: this.props.rank,
      dutyState: this.props.dutyState,
      rate: this.props.rate.id,
      cycle: this.props.cycle.id,
      fromRegular: false,
      chapters: checkedReferences,
    };
    const reser = this.state.reserveLinked ? 'Unlink from' : 'Link to';
    if (bibliography.dutyState === 'Regular') {
      bibliography.reserveLinked = this.state.reserveLinked === false;
    }
    this.props.openModal({
      modalTitle: `Link Substitute information`,
      modalContent: (
        <SimpleConfirmation
          onConfirm={() => this.props.submitBibliography(bibliography)}
          onCancel={this.props.closeModal}
          text={<div>{`Are you sure you want to ${reser}reserve?`}</div>}
          greenButton
        />
      ),
    });
  };

  getOptions = () => {
    const { permissions } = this.props;
    const options = [];

    if (
      canPerformAction('Bibliographies.AFSCExam.CreateReference', permissions)
    ) {
      options.push({
        name: 'Create Reference',
        event: this.handleCreateReference,
      });
    }

    options.push({
      name: 'View logs',
      event: this.handleViewLogs,
    });

    if (canPerformAction('Bibliographies.AFSCExam.Export', permissions)) {
      options.push({
        name: 'Download CSV',
        event: this.handleDownloadCSV,
      });
      options.push({
        name: 'Q manually set report',
        event: this.handleDownloadReport,
      });
    }

    /* if (this.props.dutyState === 'Regular' &&
      canPerformAction('Bibliographies.AFSCExam.Manage', permissions)
    ) {
      const subs = this.state.substituteLinked ? 'Unlink from' : 'Link to';
      options.push({
        name: `${subs} Substitute`,
        event: this.handleSubsLink,
      });
      Discoment when link to reserve functionality it's done.
      let reser = this.state.reserveLinked ? 'Unlink from' : 'Link to'
      options.push({
        name: `${reser}Reserve`,
        event: this.handleReserveLink,
      }); 
    } */
    return options;
  };

  getRatingExamButtons = () => {
    const { permissions } = this.props;
    const filteredCycles = this.filterCycles();
    const dropDownOptions = this.getOptions();
    const canEdit = canPerformAction(
      'Bibliographies.AFSCExam.Manage',
      permissions,
    );

    return (
      <div className="ratingButtonsContainer">
        <div className="ratingExamButtons" onClick={this.toggleViewSelected}>
          {this.state.isViewSelected ? 'View All' : 'View Selected'}
        </div>
        {canEdit && (
          <>
            <div className="ratingExamButtons" onClick={this.onClearSelected}>
              Clear selections
            </div>
            <div className="ratingExamButtonsBlue" onClick={this.handleSubmit}>
              Save Selection
            </div>
            {!this.props.isUndoChecked && (
              <div className="ratingExamButtonsBlue" onClick={this.handleUndo}>
                Undo
              </div>
            )}
            {!this.props.isRevertChecked && (
              <div
                className="ratingExamButtonsBlue"
                onClick={this.handleRevert}
              >
                Revert
              </div>
            )}
          </>
        )}
        <select
          className="selectContainerBibliographies"
          value={this.props.cycle ? this.props.cycle.id : ''}
          onChange={(event) => this.handleChangeCycle(event.target.value)}
        >
          {filteredCycles.length > 0 ? (
            filteredCycles.map((cycle) => (
              <option key={NumberUtils.obtainUniqueKey()} value={cycle.id}>
                {this.getCycleTitle(cycle)}
              </option>
            ))
          ) : (
            <option>No cycles created yet</option>
          )}
        </select>
        {dropDownOptions.length > 0 && (
          <div className="dotsContainer">
            <DropDown
              options={dropDownOptions}
              style={{
                position: 'absolute',
                right: '5px',
                zIndex: '5',
              }}
            />
          </div>
        )}
      </div>
    );
  };

  toggleViewSelected = () => {
    if (this.state.isViewSelected) {
      this.convertReferencesFromServer(
        this.props.references,
        this.props.checkedReferences,
      );
    } else {
      let itemsReferences = this.state.itemsReferences.map((r) => {
        r.chapters = r.chapters.filter((s) => s.checked);
        return r;
      });
      itemsReferences = itemsReferences.filter((r) => r.chapters.length > 0);
      this.setState({ itemsReferences });
    }
    this.setState({ isViewSelected: !this.state.isViewSelected });
  };

  getCycleTitle = (cycle) => {
    let title = `${cycle.title} - ${cycle.description}`;
    if (cycle.isActive) {
      title = `* ${title}`;
    }
    return title;
  };

  updateCheckedReferences = () => {
    if (this.state.itemsReferences.length === 0) return;
    let allChapters = [];
    const newItems = this.state.itemsReferences.map((reference) => {
      reference.chapters = reference.chapters.map((ch) => {
        ch.checked = !this.state.selectAllReferences;
        return ch;
      });
      allChapters = allChapters.concat(reference.chapters);
      return reference;
    });

    const newCheckedValues = allChapters.filter((item) => item.checked);

    if (newCheckedValues)
      this.addManyToSelection(_.pluck(newCheckedValues, 'id'));
    else this.removeManyFromSelection(newCheckedValues);
    this.props.updateCheckedReferences(_.pluck(newCheckedValues, 'id'));
    this.setState({
      itemsReferences: newItems,
      selectAllReferences: !this.state.selectAllReferences,
      isViewSelected: false,
    });
  };

  onClearSelected = () => {
    this.setState(
      { selectedChapterIds: new Set(), selectAllReferences: false },
      () => {
        this.props.updateCheckedReferences([]);
      },
    );
  };

  onChangeSelectAllReferences = () => {
    this.updateCheckedReferences();
  };

  checkReference = (id) => {
    let itemsReferences = [];
    let newChecked;

    const updatedReferences = this.state.itemsReferences.map((item) => {
      // Order the chapters by checked first, then alphabetically
      item.chapters = item.chapters.map((s) => {
        if (s.id === id) {
          newChecked = !s.checked;
          s.checked = newChecked;
        }
        return s;
      });

      itemsReferences = itemsReferences.concat(item.chapters);
      return item;
    });

    const itemsReferencesIds = itemsReferences
      .filter((item) => item.checked)
      .map((item) => item.id);

    this.props.updateCheckedReferences(itemsReferencesIds);
    this.setState(
      { itemsReferences: updatedReferences, isViewSelected: false },
      () => {
        if (typeof newChecked === 'boolean') {
          this.toggleOneInSelection(id, newChecked);
        }
      },
    );
  };

  checkReferenceGroup = (evt, id) => {
    let itemsReferences = [];
    this.state.itemsReferences.map((item, i) => {
      if (id === i) {
        item.chapters = item.chapters.map((s) => {
          s.checked = evt.target.checked; // eslint-disable-line no-self-assign
          return s;
        });
      } else {
        item.chapters = item.chapters.map((s) => {
          s.checked = s.checked;
          return s;
        });
      }
      itemsReferences = itemsReferences.concat(item.chapters);
      return item;
    });

    const itemsReferencesIds = itemsReferences
      .filter((item) => item.checked)
      .map((item) => item.id);

    const groupChapterIds =
      this.state.itemsReferences[id]?.chapters?.map((c) => c.id) || [];

    this.props.updateCheckedReferences(itemsReferencesIds);
    this.setState({ itemsReferences, isViewSelected: false }, () => {
      if (evt.target.checked) this.addManyToSelection(groupChapterIds);
      else this.removeManyFromSelection(groupChapterIds);
    });
  };

  onCheckReference = (id) => {
    this.checkReference(parseInt(id, 10));
  };

  getRatingExamContent = () => {
    if (this.props.loadingExam || this.props.loadingGrid) {
      return <Spinner text="Loading content" />;
    }
    return (
      <div style={{ paddingLeft: '0', overflowY: 'scroll', height: '100%' }}>
        <div className="select-all-option">
          <label style={{ margin: 0 }}>
            <input
              ref="checkbox"
              type="checkbox"
              value="selectAllReferences"
              name="selectAllReferences"
              checked={this.state.selectAllReferences}
              onChange={this.onChangeSelectAllReferences}
            />
            <span className="checkbox-inline" style={{ marginLeft: '10px' }}>
              Select/Deselect all
            </span>
          </label>
        </div>
        <div className="references-list">
          {this.state.itemsReferences.map((item, i) => {
            const color = item.highlightBook ? 'red' : 'black';

            if (!item.actAsParent) {
              return (
                <div key={`${item.name}_${i}`} className="referenceTitle">
                  <CheckBoxList
                    items={item.chapters.map((chapter) => ({
                      ...chapter,
                      name: (
                        <div>
                          <span
                            style={{
                              color,
                            }}
                          >
                            {item.name}
                          </span>{' '}
                          {`- ${item.description}`}{' '}
                          <span className="questions-qty">
                            ({chapter.questionCount} questions)
                          </span>
                          {!chapter.enabled ? ' (Disabled)' : ''}
                        </div>
                      ),
                    }))}
                    onChange={this.onCheckReference}
                  />
                </div>
              );
            }
            const referenceName = item.name;
            return (
              <div key={`${item.name}_${i}`}>
                <div className="referenceTitle" style={{ display: 'flex' }}>
                  <div style={{ display: 'flex', width: '90%' }}>
                    <label style={{ margin: 0 }}>
                      <input
                        ref="checkbox"
                        type="checkbox"
                        value="selectReference"
                        name="selectReference"
                        checked={(() => {
                          let checked = item.chapters.length > 0;
                          item.chapters = item.chapters.map((s) => {
                            if (!s.checked) {
                              checked = false;
                              return s;
                            }
                            return s;
                          });
                          return checked;
                        })()}
                        onChange={(evt) => {
                          this.checkReferenceGroup(evt, i);
                        }}
                      />
                      <span style={{ marginLeft: '10px' }}>
                        <span
                          style={{
                            color,
                          }}
                        >
                          {item.name}
                        </span>{' '}
                        - {item.description}
                      </span>
                    </label>
                  </div>
                  {canPerformAction(
                    'Bibliographies.AFSCExam.CreateChapter',
                    this.props.permissions,
                  ) && (
                    <div
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Create Chapter"
                    >
                      <i
                        className="fa fa-plus fa-lg"
                        onClick={() => this.handleCreateChapter(referenceName)}
                      />
                    </div>
                  )}
                </div>
                <div style={{ padding: '0px 25px', marginBottom: '10px' }}>
                  <CheckBoxList
                    items={item.chapters.map((chapter) => ({
                      ...chapter,
                      name: (
                        <div>
                          <span
                            style={{
                              color: chapter.highlightChapter ? 'red' : 'black',
                            }}
                          >
                            {chapter.name}
                          </span>
                          {` - ${chapter.description}`}{' '}
                          <span className="questions-qty">
                            ({chapter.questionCount} questions)
                          </span>
                          {!chapter.enabled ? ' (Disabled)' : ''}
                        </div>
                      ),
                    }))}
                    onChange={this.onCheckReference}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  getDeselectedCoutner = () => (
    <div className="deselectedCounter">
      Chapters Deselected: {this.state.deselectedCount}
    </div>
  );

  handleChangeCycle = (cycleId) => {
    cycleId = parseInt(cycleId, 10);

    const cycle = this.props.cycles.find((cycle) => cycle.id === cycleId);
    this.props.updateCycle(cycle);

    this.props.loadExam(
      this.props.dutyState,
      this.props.rank,
      this.props.rate.id,
      cycleId,
    );
  };

  onCanListUpdate = (rate, rank, dutyState) => {
    if (this.wereThereChanges()) {
      this.props.openModal({
        modalTitle: `Changes not saved`,
        modalContent: (
          <SimpleConfirmation
            onConfirm={() => {
              this.onListUpdate(rate, rank, dutyState);
              this.props.closeModal();
            }}
            onCancel={this.props.closeModal}
            text={<div>Changes not saved. Are you sure you want to leave?</div>}
            greenButton
          />
        ),
      });
    } else {
      this.onListUpdate(rate, rank, dutyState);
    }
  };

  wereThereChanges = () => {
    const originalReferences = this.props.originalCheckedReferences;
    const checkedReferences = this.props.checkedReferences;
    const hasChanges = !_.isEqual(
      originalReferences.sort((a, b) => a > b),
      checkedReferences.sort((a, b) => a > b),
    );
    return hasChanges;
  };

  getContent = () => {
    const { permissions, activeListTab } = this.props;
    if (
      activeListTab === 'Cycles' &&
      canPerformAction('Bibliographies.Cycles', permissions)
    ) {
      return <CyclesContainer permissions={permissions} />;
    }
    if (
      activeListTab === 'AFSC Exam' &&
      canPerformAction('Bibliographies.AFSCExam', permissions)
    ) {
      if (!this.props.rate.id) {
        return '';
      }
      return (
        <div style={{ height: '88%' }}>
          {this.getRatingExamButtons()}
          {this.getDeselectedCoutner()}
          {this.getRatingExamContent()}
        </div>
      );
    }
    return null;
  };

  onListUpdate = (rate, rank, dutyState) => {
    this.props.getRateRatingExamQuestions(rate, rank, dutyState);
    this.props.updateDutyState(dutyState);
    this.props.updateRank(rank);
    this.props.updateRate(rate);

    this.props.loadReferences(rate.id, 'rate');

    let cycle = this.filterCycles(rank, dutyState);
    cycle = cycle || [];
    cycle = cycle.filter((c) => c.isActive)[0];
    if (cycle && this.props.cycle && cycle.type !== this.props.cycle.type) {
      this.props.updateCycle(cycle);
    } else if (this.props.cycle?.id) {
      cycle = this.props.cycle;
    }
    if (cycle?.id) {
      this.props.loadExam(dutyState, rank, rate.id, cycle.id);
    } else {
      this.props.loadExamNoCycle();
    }
  };

  render() {
    const { bibliographyJson = '', rateChapterQuestionsReport = '' } =
      this.props;
    return (
      <div className="bibliography-container">
        <BibliographyList {...this.props} onListUpdate={this.onCanListUpdate} />
        <div style={{ paddingLeft: '0px', flex: 1 }}>{this.getContent()}</div>
        <div style={{ display: 'none' }} className="assignmentsTables">
          <CSVLink
            id="download"
            filename={this.state.filename}
            data={bibliographyJson}
          />
          <CSVLink
            id="downloadReport"
            filename={this.state.filename}
            data={rateChapterQuestionsReport}
          />
        </div>
      </div>
    );
  }
}
